const defaultErrorCodes = {
  DEFAULT_ERROR: 'default.error',
  DEFAULT_SERVER_ERROR: 'default.server.error',
  // RCK-1657: the request never reached the server (network down, DNS, proxy, CORS, timeout)
  NETWORK_ERROR: 'default.network.error',
  // DB-876: rate-limited public endpoints (HTTP 429) and the captcha of the public forms
  TOO_MANY_REQUESTS: 'too.many.requests',
  CAPTCHA_INVALID: 'captcha.invalid',
  CAPTCHA_REQUIRED: 'captcha.required',
};

export default defaultErrorCodes;
